module.exports = __webpack_public_path__ + "static/img/72.daa7252.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/72.png
// module id = zKeU
// module chunks = 1